import exportButtonRed from "./TJExportButtonRed.svg";
import vendorIconRed from "./VendorIconRed.svg";
import volumeIconRed from "./VolumeIconRed.svg";
import salesIconRed from "./SalesIconRed.svg";
import packageIconRed from "./PackageIconRed.svg";
import shelfLifeIconRed from "./ShelfLifeIconRed.svg";
import retailTagIconRed from "./RetailTagIconRed.svg";
import retailStructureIconRed from "./RetailStructureIconRed.svg";
import productSizeIconRed from "./ProductSizeIconRed.svg";
import casePackIconRed from "./CasePackIconRed.svg";
import logisticsIconRed from "./LogisticsIconRed.svg";
import facilitiesIconRed from "./FacilitiesIconRed.svg";
import whereAreFacilitiesIconRed from "./WhereAreFacilitiesIconRed.svg";
import editIcon from "./EditIcon.svg"
import deleteIcon from "./DeleteIcon.svg"
import AddCompoundIcon from "./AddCompoundIcon.svg"
import CloseButton from "./CloseButton.svg"
import legacyIncompleteIcon from "./LegacyIncompleteIcon.svg"

export {
  exportButtonRed,
  vendorIconRed,
  volumeIconRed,
  salesIconRed,
  packageIconRed,
  shelfLifeIconRed,
  retailTagIconRed,
  retailStructureIconRed,
  productSizeIconRed,
  casePackIconRed,
  logisticsIconRed,
  facilitiesIconRed,
  whereAreFacilitiesIconRed,  
  editIcon,
  deleteIcon,
  AddCompoundIcon,
  CloseButton,
  legacyIncompleteIcon
};
